import React, { useEffect, useState, useContext, useRef } from "react";
import { QRCodeSVG } from "qrcode.react";
import { lumCalc, gradColor } from "../../../utils/functions/lumCalc";
import serverProvider from "../../../providers/serverProvider";
import Toast from "../../../components/Toast/Toast";
import Loader from "../../../components/Loader/Loader";
import NotFound from "../../../components/notFound/notFound";
import { InformationPopUpContext } from "../../../contexts/informationPopUp";
import SeloSecurity from "../../../components/SeloSecurity/SeloSecurity";
import { FileCopyOutlined } from "@material-ui/icons";
import logoImg from "../../../assets/images/logo.png";
import brasil from "../../../assets/images/brasil.png";
import alertTriangle from "../../../assets/images/alertTriangle.svg";
import logoMrpay from "../../../assets/images/logo.png";
import alert from "../../../assets/images/alert.svg";
import compraSeguraLogo from "../../../assets/images/compra_segura.svg";

import {
  InfoPixContainer,
  CheckoutLPContainer,
  ProductInfo,
  HeaderInfoContents,
  LogoImg,
  CheckoutLPFlag,
  CheckoutLPBrasil,
  AlertTriangle,
  PurchaseSummary,
  TitleProducts,
  BoxProductValues,
  PurchaseDetails,
  LineDivider,
  PixInstruction,
  PixPayment,
  PixBox,
  LoaderStyle,
  PixCode,
  CopyButton,
  ErrorMessage,
  LogoMrImg,
  DivLogoImg,
} from "./CheckoutPixstyles";

const toMoneyFormat = (value) => {
  return Number(value / 100).toLocaleString("pt-br", {
    style: "currency",
    currency: "BRL",
  });
};

const discountValue = (discount) =>
  !discount.cart.discount
    ? 0
    : discount.cart.discount.type === "amount"
    ? discount.cart.discount.value
    : subtotalValue(discount) * (discount.cart.discount.value / 100);

// Retorna os total de juros da parcela escolhida
const getInterestValue = (interest_amount, amount) => {
  return Number(interest_amount) - Number(amount);
};

const subtotalValue = (checkout) =>
  checkout.cart.items.reduce((acc, cur) => {
    const quantity_value = !cur.quantity || cur.quantity < 0 ? 1 : cur.quantity;
    return acc + Number(cur.product_price) * quantity_value;
  }, 0);

const success_state = ["CON", "PPC", "PEN"];

const failure_state = ["INV", "NEG", "BLQ"];

const cancel_state = ["PPN", "ERR", "EXP", "CAN"];

function CheckoutPix(props) {
  const [stage, setStage] = useState(0);
  const attempt = props.location.state?.attempt;
  const config_payload = props.location.state?.config_payload;
  const checkout_payload = props.location.state?.checkout_payload;
  const transaction_values = props.location.state?.data;
  const values = props.location.state?.info;
  const testMode = props.location.state?.testMode;

  const renderized = useRef(true);
  const [toastMessage, setToastMessage] = useState("");
  const [qrCode, setQrCode] = useState(false);
  const [qrLoading, setQrLoading] = useState(false);
  const { showInformationPopUp } = useContext(InformationPopUpContext);

  useEffect(() => {
    // setStage(1);

    if (config_payload && checkout_payload && transaction_values.amount) {
      setQrLoading(true);
      createTransactionPix(transaction_values.amount)
        .then((response) => setQrCode(response.qr_code))
        .catch((e) => {
          setQrLoading(false);
          showInformationPopUp({ title: "Falha", message: "Erro ao processar o PIX" });
          console.log("[e - catch]", e);
        });

      // Renderiza a página
      setStage(1);
    } else {
      // Página de não encontrado
      setStage(2);
    }
  }, []);

  useEffect(() => {
    return () => {
      console.log("[encerrando verificação de pagamento]");
      renderized.current = false;
    };
  }, []);

  const createTransactionPix = (amount) => {
    return new Promise(async (resolve, reject) => {
      try {
        const transaction_response = await serverProvider(testMode).createTransactionWithPix(
          amount,
          checkout_payload,
          values,
          transaction_values
        );
        console.log("[transaction_response]", transaction_response);

        verifyPixPayment(transaction_response.payment.nit);

        setQrLoading(false);
        resolve(transaction_response.payment);
      } catch (e) {
        console.log("[e]", e);
        return reject(e);
      }
    });
  };

  const verifyPixPayment = async (nit) => {
    console.log("Consultando...");

    try {
      if (renderized) {
        const pixConsult = await serverProvider(testMode).checkPixPayment(nit, checkout_payload);
        console.log("[pixConsult]", pixConsult);

        if (pixConsult.status === "PEN") {
          console.log("Pendente...");
          setTimeout(() => {
            verifyPixPayment(nit);
          }, 6 * 1000); // 10 segudos
        } else {
          if (pixConsult.success) {
            console.log("Entrou no success");
            renderized.current = false;
            redirectToEndPage(pixConsult.data, "payment");
          } else {
            console.log("Talvez nunca entre aqui, borav");
          }
        }
      }
    } catch (error) {
      console.log("[pix - error]", error);
      showInformationPopUp({ title: "Falha no pagamento PIX", message: error.message });
    }
  };

  const redirectToEndPage = (transactionResponse, type) => {
    const end_payload = {
      // id: _id,
      count: attempt,
      message: transactionResponse.message,
      response_message: transactionResponse[type].authorizer_message,
      payment_detail: {
        type: "PIX",
        establishment: checkout_payload.document_number,
        authorization_number: transactionResponse[type].authorization_number,
        emrpay_usn: transactionResponse[type].emrpay_usn,
        amount:
          transactionResponse[type].payment_amount ||
          transaction_values.interest_amount ||
          transaction_values.amount,
        installment: transaction_values.parcels,
        authorizer_id: transactionResponse[type].authorizer_id,
        payment_type: transactionResponse[type].payment_type || transaction_values.paymentForm,
        payment_date: transactionResponse[type].payment_date,
      },
      transaction_detail: {
        order: checkout_payload.merchant_order_id,
        interest_value: transaction_values.amount,
        product_detail: checkout_payload.cart,
        discount_pix: transaction_values.discount_pix,
        shipping_detail: checkout_payload.shipping
          ? {
              type: checkout_payload.shipping?.type || "",
              delivery_name: values.deliveryType[values.deliveryChoice]?.name || "",
              delivery_price: values.deliveryType[values.deliveryChoice]?.price || "",
              delivery_time: values.deliveryType[values.deliveryChoice]?.deadline || "",
            }
          : "",
      },
      payer_data: {
        name: values.identificationName,
        phone: values.phone,
        email: values.email,
      },
      style_page: {
        logo: config_payload.exhibition?.logo || "",
        background_color: config_payload.exhibition?.background_color || "",
      }
    };

    if (success_state.includes(transactionResponse[type].status)) {
      props.history.push("/checkout/success", end_payload);
    }

    if (failure_state.includes(transactionResponse[type].status)) {
      props.history.push("/checkout/failure", end_payload);
    }

    if (cancel_state.includes(transactionResponse[type].status)) {
      props.history.push("/checkout/cancel", end_payload);
    }
  };

  return (
    <>
      {stage === 1 && (
        <>
          <CheckoutLPBrasil>
            <CheckoutLPFlag src={brasil} alt="MrPay" />
            <p>Transação processada no Brasil</p>
          </CheckoutLPBrasil>

          <CheckoutLPContainer
            bgColor={config_payload.exhibition?.background_color || "#f6f6f6"}
            gradientColor={gradColor(
              (config_payload?.exhibition && config_payload.exhibition?.background_color) || ""
            )}
          >
            <PixPayment>
              <InfoPixContainer>
                <HeaderInfoContents>
                  <LogoImg
                    src={(config_payload?.exhibition && config_payload.exhibition?.logo) || logoImg}
                    alt="MrPay"
                  />
                  <SeloSecurity
                    bgColor={
                      (config_payload?.exhibition && config_payload.exhibition?.background_color) ||
                      "#F1B434"
                    }
                  />
                </HeaderInfoContents>

                <PixInstruction>
                  <div className="pix-alert">
                    <AlertTriangle src={alertTriangle} alt="MrPay" />
                    <p>
                      Realize o pagamento em até <strong> 30 minutos </strong> para processarmos o seu
                      pedido!
                    </p>
                  </div>

                  <div className="pix-intructions">
                    <h4>Como pagar com o PIX?</h4>
                    <p>
                      1. Faça login no app da sua instituição financeira e acesse o ambiente pix;
                      <br />
                      2. Escolha a opção de ler o QR Code;
                      <br />
                      3. Escaneie o QR Code;
                      <br />
                      4. Confirme as informações e realize o pagamento.
                    </p>

                    {/* <div style={{ backgroundColor: lightenedColor }}>
                      <h3>teste gradient</h3>
                    </div> */}
                  </div>
                </PixInstruction>

                {qrLoading ? (
                  <LoaderStyle>
                    <Loader />
                  </LoaderStyle>
                ) : qrCode ? (
                  <div>
                    <PixBox>
                      <p>APONTE A CÂMERA DO SEU CELULAR</p>
                      <div className="captcha">
                        <QRCodeSVG value={qrCode} />
                      </div>
                    </PixBox>

                    <PixCode>
                      <h4>Em caso de erro, clique abaixo para copiar o código:</h4>
                      <CopyButton
                        onClick={() => {
                          navigator.clipboard.writeText(qrCode);
                          setToastMessage("Código copiado pra área de transferência");
                        }}
                      >
                        <FileCopyOutlined fontSize="large" />
                      </CopyButton>
                    </PixCode>
                  </div>
                ) : (
                  <ErrorMessage>
                    <span>Erro ao gerar QRCode</span>
                  </ErrorMessage>
                )}

                <div className="info">
                  <h4>Informações sobre o pagamento:</h4>
                  <p>
                    Após finalizar o pedido, realize o pagamento em até 30 minutos. Caso contrário, o
                    pedido será cancelado e um novo deverá ser feito. Lembre-se que Ofertas podem ter
                    expirado após esse período.
                  </p>
                </div>
              </InfoPixContainer>

              {checkout_payload && (
                <PurchaseSummary>
                  <TitleProducts>Resumo da compra</TitleProducts>
                  {"cart" in checkout_payload ? (
                    checkout_payload.cart?.items.map((item, key) => (
                      <BoxProductValues key={key}>
                        <div className="productsAndPrices">
                          <h4>{item.product_name}</h4>
                          <h2>{toMoneyFormat(item.product_price)}</h2>
                          {item.quantity && <h4>Quantidade: {item.quantity}</h4>}
                        </div>
                        <div className="alert">
                          <img src={alert} alt="" />
                        </div>
                      </BoxProductValues>
                    ))
                  ) : (
                    <></>
                  )}

                  <PurchaseDetails>
                    <div className="textLine">
                      <h2 className="textLeft">Subtotal:</h2>
                      <h3 className="textRight">
                        {"cart" in checkout_payload ? (
                          toMoneyFormat(subtotalValue(checkout_payload))
                        ) : (
                          <></>
                        )}
                      </h3>
                    </div>

                    {checkout_payload.cart?.discount && checkout_payload.cart?.discount?.value !== 0 ? (
                      <div className="textLine">
                        <h2 className="textLeft">Desconto:</h2>
                        <h3 className="textRight">- {toMoneyFormat(discountValue(checkout_payload))}</h3>
                      </div>
                    ) : (
                      <></>
                    )}

                    {config_payload.payments?.discount_for_payment_with_Pix ? (
                      <div className="textLine">
                        <h2 className="textLeft">Desconto (Pix %):</h2>
                        <h3 className="textRight">- {toMoneyFormat(transaction_values.discount_pix)}</h3>
                      </div>
                    ) : (
                      <></>
                    )}

                    {checkout_payload.shipping &&
                      checkout_payload.shipping?.type !== "without_shipping_pick_up" && (
                        <div className="textLine">
                          <h2 className="textLeft">Frete:</h2>
                          <h3 className="textRight">{toMoneyFormat(values.deliveryType[values.deliveryChoice]?.price || "")}</h3>
                        </div>
                      )}

                    {transaction_values.paymentForm === "credCard" &&
                      transaction_values.interest_amount && (
                        <div className="textLine">
                          <h2 className="textLeft">Juros de parcelamento:</h2>
                          <h3 className="textRight">
                            {toMoneyFormat(
                              getInterestValue(
                                transaction_values.interest_amount,
                                transaction_values.amount
                              )
                            )}
                          </h3>
                        </div>
                      )}

                    <LineDivider />

                    <div className="totalTextLine">
                      <span className="textLeft">Total:</span>
                      <span className="textRight">
                        {toMoneyFormat(transaction_values.interest_amount || transaction_values.amount)}
                      </span>
                    </div>
                  </PurchaseDetails>
                  <DivLogoImg>
                    <LogoMrImg src={compraSeguraLogo} />
                  </DivLogoImg>
                </PurchaseSummary>
              )}
            </PixPayment>
          </CheckoutLPContainer>
        </>
      )}
      {stage === 2 && (
        <>
          <NotFound />
        </>
      )}
      <Toast message={toastMessage} setMessage={setToastMessage} />
    </>
  );
}

export { CheckoutPix };
